var React = require('react');

function Pause (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2 14C3.1 14 4 13.1 4 12V2C4 0.9 3.1 0 2 0C0.9 0 0 0.9 0 2V12C0 13.1 0.9 14 2 14ZM8 2V12C8 13.1 8.9 14 10 14C11.1 14 12 13.1 12 12V2C12 0.9 11.1 0 10 0C8.9 0 8 0.9 8 2Z","fill":"currentColor"}));
}

Pause.defaultProps = {"viewBox":"0 0 12 14","fill":"none"};

module.exports = Pause;

Pause.default = Pause;
